import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSnackbar, Icon, IconButton, Spacer, Stack, Typography } from '@emburse/embark-core';
import { DeleteIcon } from '@emburse/embark-icons';
import { useState } from 'react';
import { deleteAuditExceptions } from '../../../../api/audit';
import { $t } from '../../../../hooks/useTranslation';
export default function ExceptionDetailsList({ exceptionDetails, auditDefPayload, exceptionDetailType, refreshExceptionDetails }) {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    return (_jsx(_Fragment, { children: exceptionDetails.map((exception) => (_jsxs(Stack, { alignItems: "flex-start", spacing: 1, sx: { width: '100%' }, children: [_jsx(Spacer, { size: 2, sx: { width: '100%', backgroundColor: '#eee' } }), _jsxs(Stack, { alignItems: "center", direction: "row", justifyContent: "space-between", sx: { width: '100%' }, children: [_jsxs(Stack, { alignItems: "flex-start", spacing: 1, children: [_jsx(Typography, { variant: "body1", children: exception.TypeValue }), _jsxs(Typography, { variant: "body2", children: ["Created by\u00A0", exception.LastModUser, ",\u00A0", new Date(exception.LastModDate).toDateString()] })] }), _jsx(IconButton, { color: "error", disabled: loading, onClick: async () => {
                                try {
                                    setLoading(true);
                                    await deleteAuditExceptions({
                                        AuditDefPK: auditDefPayload.AuditDefPK,
                                        ExceptionType: exceptionDetailType,
                                        ExceptionPKs: [exception.PK]
                                    });
                                    await refreshExceptionDetails();
                                    enqueueSnackbar($t('Exception deleted successfully'), {
                                        variant: 'success'
                                    });
                                }
                                catch (error) {
                                    enqueueSnackbar($t('Error deleting exception'), {
                                        variant: 'error'
                                    });
                                }
                                finally {
                                    setLoading(false);
                                }
                            }, "data-qa": "delete-exception-button", children: _jsx(Icon, { iconUrl: DeleteIcon }) })] }), _jsx(Spacer, { size: 2 })] }, exception.PK))) }));
}
